import Accordion from '@/components/molecules/Accordion';
import { GOOGLE_TRACK_INFO } from '@/lib/constants';
import { useRouter } from 'next/compat/router';
import { FC, ReactNode } from 'react';

export interface CategoryQuestion {
  category?: string;
  questions: {
    header: string;
    text: ReactNode;
  }[];
}

export interface FrequentlyAskedQuestionsProps {
  subHeading?: string;
  newUI?: boolean;
  headingClassName?: string;
  subHeadingClassName?: string;
  questionGroups: CategoryQuestion[];
}

const FrequentlyAskedQuestions: FC<FrequentlyAskedQuestionsProps> = ({
  subHeading,
  newUI,
  headingClassName = '',
  subHeadingClassName = '',
  questionGroups,
}) => {
  const router = useRouter();
  return (
    <section className="col-span-full m:col-span-10 m:col-start-1 l:col-span-10 l:col-start-2 xl:col-span-8 xl:col-start-3">
      <h2
        className={`mb-[20px] mt-[20px] text-center font-semibold ${
          newUI
            ? 'text-title24px md:text-display32px'
            : 'text-center text-h2SemiBold tracking-wider text-blue-dark m:text-h1SemiBold l:text-6xl xl:text-6xl'
        } ${headingClassName}`}
      >
        Frequently Asked Questions
      </h2>
      {subHeading && (
        <p
          className={`mb-[60px] text-center text-h4Regular text-neutral-800 ${subHeadingClassName}`}
        >
          {subHeading}
        </p>
      )}
      <ul>
        {questionGroups.map(({ category, questions }, questionGroupIndex) => (
          <div
            key={`CATEGORY-${category}-${questionGroupIndex}`}
            className="mb-[40px]"
          >
            {category && (
              <p
                className={`mb-[20px] px-l text-center text-h4Regular text-neutral-800`}
              >
                {category}
              </p>
            )}
            {questions.map(({ header, text }, questionIndex) => (
              <li key={`QUESTION-${header}-${questionIndex}`}>
                <Accordion
                  title={
                    <h3 className="text-body1Medium text-neutral-900">
                      {header}
                    </h3>
                  }
                  className="rounded-xsmall border-b-[1px] p-l md:hover:bg-neutral-200"
                  analyticsEvent={{
                    ...GOOGLE_TRACK_INFO.frequentlyAskedQuestionsButton,
                    pageTarget: router?.pathname,
                  }}
                >
                  <p
                    className={`whitespace-pre-line text-body2Regular text-neutral-800`}
                  >
                    {text}
                  </p>
                </Accordion>
              </li>
            ))}
          </div>
        ))}
      </ul>
    </section>
  );
};

export default FrequentlyAskedQuestions;
